import React, { Component } from "react";
import cn from "classnames";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import messages from "./stepper-messages";
import "./stepper.scss";

const createDots = (count, step) => {
  const array = [];
  for (let i = 0; i <= count - 1; i++) {
    array.push(
      <span
        key={i}
        role="listitem"
        className={cn(
          "stepper__dot",
          `stepper__dot${i === Number(step) && "--active"}`
        )}
      />
    );
  }
  return array;
};

class Stepper extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref.current.focus();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.step !== this.props.step) {
      this.ref.current.focus();
    }
  }

  render() {
    const {
      title,
      total,
      step,
      intl: { formatMessage }
    } = this.props;
    const dots = createDots(total, step);
    const ariaLabel = formatMessage(
      { ...messages.currentStepLabel },
      {
        title,
        step: step + 1,
        total
      }
    );

    return (
      <div
        aria-label={ariaLabel}
        role="list"
        tabIndex="-1"
        ref={this.ref}
        className="stepper"
      >
        {dots}
      </div>
    );
  }
}

Stepper.propTypes = {
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  step: PropTypes.number
};

export { Stepper };
export default injectIntl(Stepper);
